export default {
  name: 'имя',
  contacts: 'контактные данные',
}



// WEBPACK FOOTER //
// ./src/strings/validator/attributes/ru.js